import React, { Suspense, lazy } from "react";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
// hooks
import useAppConfig from "./hooks/useAppConfig";
// components
import LoadingScreen from "./components/LoadingScreen"

const AppDesktop = lazy(() => import('./AppDesktop'));

function App() {
    const { isInitialized, appConfig } = useAppConfig();
    return (
        <>
            <Helmet>
                <title>{isInitialized ? appConfig !== null ? appConfig.companyName : "crm-x" : "Loading..."}</title>
            </Helmet>
            {isInitialized ?
                <Suspense fallback={<LoadingScreen />}>
                    <AppDesktop />
                </Suspense>
                : <LoadingScreen />}
        </>
    )
}

export default Sentry.withProfiler(App);
